import { render, staticRenderFns } from "./AtencionModalUploads.vue?vue&type=template&id=2451b794"
import script from "./AtencionModalUploads.vue?vue&type=script&lang=js"
export * from "./AtencionModalUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports